import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "./contexts/AuthContext";
import Header from "./layout/Header/Header";
import { puede, permisoDeRuta, rutaBloqueada } from "../permisos/permisos";

// Revisa el permiso de la pantalla antes de mostrarla. Antes solo se ocultaba el boton del
// menu: cualquiera con sesion entraba escribiendo la direccion.
//   - Rutas del sistema textil/escolar (catalogo.rutasBloqueadas): nadie entra.
//   - Rutas del catalogo: hace falta el permiso de esa pantalla (o de su accion, p.ej. crear).
//   - El resto (inicio, login, portal de clientes...): libre, como siempre.
function SinAcceso({ motivo }) {
  return (
    <>
      <Header />
      <div className="container" style={{ paddingTop: 60, textAlign: "center" }}>
        <i className="fas fa-lock" style={{ fontSize: "2.5rem", color: "#94a3b8" }} />
        <h4 style={{ marginTop: 16, color: "#334155" }}>Sin acceso</h4>
        <p style={{ color: "#64748b" }}>{motivo}</p>
        <a href="/Inicio" className="btn btn-sm btn-primary">
          Ir al inicio
        </a>
      </div>
    </>
  );
}

function GuardiaRutas({ children }) {
  const { isAuth, user } = useContext(AuthContext);
  const { pathname } = useLocation();

  // Sin sesion cada pantalla manda al login como siempre.
  if (!isAuth || !user) return children;

  if (rutaBloqueada(pathname)) {
    return <SinAcceso motivo="Esta pantalla ya no se usa en el sistema." />;
  }
  const permiso = permisoDeRuta(pathname);
  if (permiso && !puede(user, permiso)) {
    return <SinAcceso motivo="No tienes permiso para esta pantalla. Pídeselo al administrador." />;
  }
  return children;
}

export default GuardiaRutas;
